<template>
    <van-tabs type="card" color="#07C160" sticky :offset-top="100">
        <van-tab style="margin-top: 10px" title="办理类目">
            <van-cell-group>

                <van-row>
                    <van-col span="20">
                        <van-field label="办理抵押" readonly v-model="loanApplyExtends[0].handleEmpName" @click="pop(0)" />
                    </van-col>
                    <van-col span="4" style="margin-top: 10px">
                        <van-switch :disabled="read" v-model="loanApplyExtends[0].checked" size="22px"
                            @change="switchChange($event, 0)" />
                    </van-col>
                    <van-field label="备注" :readonly="read" v-model="loanApplyExtends[0].exNote" placeholder="请输入备注" />
                </van-row>

                <van-row>
                    <van-col span="20">
                        <van-field label="办理强执公证" :readonly="read" v-model="loanApplyExtends[1].handleEmpName"
                            @click="pop(1)" placeholder="请输入办理人" />
                    </van-col>
                    <van-col span="4" style="margin-top: 10px">
                        <van-switch :disabled="read" v-model="loanApplyExtends[1].checked" size="22px"
                            @change="switchChange($event, 1)" />
                    </van-col>
                    <van-field label="备注" :readonly="read" v-model="loanApplyExtends[1].exNote" placeholder="请输入备注" />
                </van-row>

                <van-row>
                    <van-col span="20">
                        <van-field label="完成签约" :readonly="read" v-model="loanApplyExtends[2].handleEmpName"
                            @click="pop(2)" placeholder="请输入办理人" />
                    </van-col>
                    <van-col span="4" style="margin-top: 10px">
                        <van-switch :disabled="read" v-model="loanApplyExtends[2].checked" size="22px"
                            @change="switchChange($event, 2)" />
                    </van-col>
                    <van-field label="备注" :readonly="read" v-model="loanApplyExtends[2].exNote" placeholder="请输入备注" />
                </van-row>

            </van-cell-group>
        </van-tab>

        <van-tab style="margin-top: 10px" title="抵押附件">

            <van-collapse v-model="actives">
                <van-collapse-item title="担保措施" name="1">
                    <oss-upload style="margin-top: 10px;" :isUpload="parseInt(auditStatus) == 7" :applyId="applyId"
                        :groupCode="400" refName="dbcs"></oss-upload>
                </van-collapse-item>
                <van-collapse-item title="贷后报告附件" name="2">
                    <oss-upload style="margin-top: 10px;" :isUpload="parseInt(auditStatus) == 7" :applyId="applyId"
                        :groupCode="71" refName="dhbg"></oss-upload>
                </van-collapse-item>
                <van-collapse-item title="资金用途材料" name="3">
                    <oss-upload style="margin-top: 10px;" :isUpload="parseInt(auditStatus) == 7" :applyId="applyId"
                        :groupCode="7101" refName="zijt"></oss-upload>
                </van-collapse-item>
                <van-collapse-item title="担保函" name="4">
                    <oss-upload style="margin-top: 10px;" :isUpload="parseInt(auditStatus) == 7" :applyId="applyId"
                        :groupCode="150" refName="dbh"></oss-upload>
                </van-collapse-item>

            </van-collapse>

        </van-tab>

        <!-- 申请信托审核 -->
        <van-dialog v-if="auditStatus == '8'" v-model="confirmLoanAuditShow" :title="auditTitle" show-cancel-button
            :before-close="auditPass" @cancel="confirmLoanAuditShow = false">

            <van-field style="margin: 10px 0" type="number" label="本次放款" clearable v-model="advanceAmount"
                :error-message="advanceAmountErr" />

            <van-field style="margin: 10px 0" type="text" label="补充材料" readonly clearable @click="documentShow"
                :error-message="supDocumentErr" placeholder="单击可选择" v-model="supDocument" />

            <van-radio-group v-model="conditionalPass" @change="conditionalPassChange">
                <div style="padding: 20px 0 10px 20px;font-size: 14px;color:#07c160">
                    <van-icon name="info-o" />
                    是否有条件通过
                </div>
                <van-cell-group>
                    <van-cell title="正常批贷" clickable @click="clickConditional('normal')">
                        <van-radio slot="right-icon" name="normal" />
                    </van-cell>
                    <van-cell title="放款后需补充担保措施" clickable @click="clickConditional('needSup')">
                        <van-radio slot="right-icon" name="needSup" />
                    </van-cell>
                </van-cell-group>
            </van-radio-group>

            <van-field style="margin: 10px 0" type="textarea" label="审批意见" clearable :error-message="remarkErr"
                placeholder="请输入审批意见" v-model="remark" />

        </van-dialog>

        <van-dialog title="补充资料" :before-close="confirmSupDocument" show-cancel-button v-model="supDocumentShow">
            <van-checkbox-group v-model="supDocumentTemp">
                <van-cell-group>

                    <van-cell clickable title="他项权利" @click="toggle(1)">
                        <van-checkbox name="他项权利" ref="supDoc1" slot="right-icon" />
                    </van-cell>

                    <van-cell clickable title="转账凭证" @click="toggle(2)">
                        <van-checkbox name="转账凭证" ref="supDoc2" slot="right-icon" />
                    </van-cell>

                </van-cell-group>
            </van-checkbox-group>
        </van-dialog>

    </van-tabs>
</template>

<script>
import { addHandle, getHandle, auditProcess, rejectProcess } from '@/api/loanInfo'
import {eventBus} from '@/vue/utils/eventBus'
import { mapGetters } from 'vuex'
import FilesUpload from '@/views/home/business/mortgage/files-upload.vue'
import ossUpload from '@/views/component/oss-upload'

const _ = require('lodash')
export default {
    name: 'mortgage_guarantee',
    props: {
        applyId: {
            type: String,
            default: ''
        }
    },
    watch: {
        'remark'(val) {
            if (val == undefined || val.length > 0) {
                this.remarkErr = ''
            }
        },
        'advanceAmount'(val) {
            if (val == undefined || val.length > 0) {
                this.advanceAmountErr = ''
            }
        }
    },
    components: {
        FilesUpload,
        ossUpload
    },
    computed: mapGetters([
        'auditStatus',
        'applyInfo',
        'userId',
        'userName',
        'name'
    ]),
    data() {
        return {
            conditionalPass: 'normal',
            supDocumentTemp: [],
            supDocument: '',
            supDocumentErr: '',
            supDocumentColumns: ['他项权利', '转账凭证'],
            load: true,
            actives: [],
            files: [],
            value: '',
            users: [],
            index: -1,
            list: [],
            read: true,
            loading: false,
            finished: false,
            show: false,
            activate: [],
            advanceAmount: '',//本次放款金额
            advanceAmountErr: '',//本次放款金额
            confirmLoanAuditShow: false,
            supDocumentShow: false,
            showDoc: false,//是否可以选择补充资料
            remark: '',
            remarkErr: '',
            auditTitle: '',
            loanApplyExtends: [
                {
                    id: '',
                    checked: false,
                    handle: '',
                    handleEmpName: '',
                    handleEmp: '',
                    exCode: 'MORTGAGE',
                    exCn: '是否已办理抵押',
                    exNote: ''
                },
                {
                    id: '',
                    checked: false,
                    handle: '',
                    handleEmpName: '',
                    exCode: 'FORCE_NOTARY',
                    handleEmp: '',
                    exCn: '是否已办理强执公证',
                    exNote: ''
                },
                {
                    id: '',
                    checked: false,
                    handle: '',
                    handleEmpName: '',
                    handleEmp: '',
                    exCode: 'SIGN_COMPLETE',
                    exCn: '是否已完成签约',
                    exNote: ''
                },
            ]
        }
    },
    mounted() {
        let self = this
        this.getHandles()
        setTimeout(function () {
            if (self.auditStatus == '7') {
                self.read = false
            }
        }, 600)

        //初始化审批事件 type:1 保存担保措施 2 风控确认放款审批
        eventBus.$on('mortgageAudit', function (type) {
            if (type == 1) {
                // 审批操作
                self.audit()
            } else {
                // 风控确认放款审批
                self.auditTitle = '确认放款条件'
                self.confirmLoanAuditShow = true
            }
        })

        self.advanceAmount = self.applyInfo.advanceAmount

    },
    destroyed() {
        eventBus.$off('mortgageAudit')
    },
    methods: {
        toggle(index) {
            if (index == 1) {
                this.$refs.supDoc1.toggle();
            } else {
                this.$refs.supDoc2.toggle();
            }
        },
        audit() {
            //保存办理类目
            this.saveWarrent()
        },
        auditPass(action, done) {
            if (action === 'confirm') {
                //补充担保措施需要验资 补充材料
                if (this.conditionalPass == 'needSup' && !this.supDocument) {
                    this.$toast('请选择补充材料')
                    done(false)
                    return false
                }

                //审批意见校验
                if (!this.remark) {
                    this.remarkErr = '请输入审批意见'
                    done(false)
                    return false
                }

                //提交请求
                let params = {
                    applyId: this.applyId,
                    type: 'pass',
                    process: 'TRUST_LOAN_APPROVAL',
                    remark: this.remark,
                    conditionalPass: this.conditionalPass
                }

                //需要补充资料
                if (this.conditionalPass == 'needSup') {
                    params.supDocument = this.supDocument
                }
                auditProcess(params).then(res => {
                    done()
                    if (res.success) {
                        this.$toast(res.msg)
                        this.$router.go(-1)
                    } else {
                        this.$toast(res.msg)
                    }
                })

            } else {
                this.remarkErr = ''
                done()
            }
        },
        conditionalPassChange(val) {
            this.conditionalPass = val
            //不能再选补充材料
            if (val == 'normal') {
                this.showDoc = false
                //清空补充材料
                this.supDocument = ''
            } else {
                this.showDoc = true
            }
        },
        clickConditional(val) {
            this.conditionalPass = val
            //不能再选补充材料
            if (val == 'normal') {
                this.showDoc = false
                this.supDocument = ''
            } else {
                this.showDoc = true
            }
        },
        documentShow() {
            if (this.showDoc) {
                this.supDocumentShow = true
            } else {
                this.$toast('正常批贷无需补充材料')
            }
        },

        confirmSupDocument(action, done) {
            console.log(action, this.supDocumentTemp.length)
            if (action === 'confirm') {
                if (this.supDocumentTemp.length > 0) {
                    this.supDocument = this.supDocumentTemp.join(',')
                    console.log(this.supDocument)
                }
            } else {

            }
            done()
        },
        getHandles() {
            let self = this
            let data = {
                applyId: this.applyId
            }
            getHandle(data).then(res => {
                if (res.success) {
                    if (res.data.length > 0) {
                        res.data.forEach((item, index) => {
                            if (item.handle === 'YES') {
                                item.checked = true
                            } else {
                                item.checked = false
                            }
                            for (let i = 0; i < self.loanApplyExtends.length; i++) {
                                if (self.loanApplyExtends[i].exCode == item.exCode) {
                                    self.loanApplyExtends[i].id = item.id
                                    self.loanApplyExtends[i].handle = item.handle
                                    self.loanApplyExtends[i].handleEmpName = item.handleEmpName
                                    self.loanApplyExtends[i].handleEmp = item.handleEmp
                                    self.loanApplyExtends[i].exCode = item.exCode
                                    self.loanApplyExtends[i].exCn = item.exCn
                                    self.loanApplyExtends[i].exNote = item.exNote
                                    if (item.handle == 'YES') {
                                        self.loanApplyExtends[i].checked = true
                                    }
                                }
                            }
                        })
                    }
                }
            })
        },
        saveWarrent() {
            let dataExtends = _.cloneDeep(this.loanApplyExtends)

            dataExtends.forEach((item, index) => {
                delete dataExtends[index].checked
            })

            let data = {
                applyId: this.applyId,
                loanApplyExtends: dataExtends
            }
            addHandle(data).then(res => {
                if (res.success) {
                    this.$toast('保存权证信息成功')
                }
            })

        },
        pop(index) {
            if (!this.read) {
                this.show = true
                this.index = index
            }
        },
        back() {
            this.show = false
        },
        selectUser(item) {
            if (this.index != -1) {
                this.loanApplyExtends[this.index].handleEmp = item.account
                this.loanApplyExtends[this.index].handleEmpName = item.realName
                this.show = false
            }
        },
        switchChange(checked, index) {
            this.loanApplyExtends[index].handleEmpName = this.name
            this.loanApplyExtends[index].handleEmp = this.userName
            this.loanApplyExtends[index].checked = checked
            if (checked) {
                this.loanApplyExtends[index].handle = 'YES'
            } else {
                this.loanApplyExtends[index].handle = 'NO'
            }
        }

    }
}
</script>

<style scoped></style>
